// config.js
const config = {
  accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
  trustKey: process.env.REACT_APP_NEW_RELIC_TRUST_KEY,
  agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
  licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
  applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  wsBaseUrl: process.env.REACT_APP_WS_BASE_URL,
};

export default config;
